
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...pathRouter]",
      function () {
        return require("private-next-pages/[...pathRouter].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...pathRouter]"])
      });
    }
  